module.exports = __webpack_public_path__ + "static/img/Stewart.Crameri.402f4a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stewart.Crameri.jpg
// module id = zv+L
// module chunks = 0